import React from 'react';
import { Checkbox, Alert } from 'antd';
import PropTypes from 'prop-types';

const renderField = ({ input, label, meta: { touched, error } }) => (
  <div>
    <Checkbox
      name={input.name}
      checked={input.value}
      onClick={() => input.onChange(!input.value)}
    >
      {label}
    </Checkbox>
    {touched && error && <Alert message={error} type="error" />}
  </div>
);
renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
};

export default renderField;
